import {Component, Inject, NgZone, OnDestroy, OnInit} from '@angular/core';
import {Subscription} from "rxjs";
import {ResizeService} from "../service/resize.service";

@Component({
  selector: 'app-main-window',
  templateUrl: './main-window.component.html',
  styleUrls: ['./main-window.component.css']
})
export class MainWindowComponent implements OnDestroy {

  height: number;
  subscription: Subscription;

  constructor(resizeService: ResizeService,
              ngZone: NgZone,
              @Inject('HeightOffset') private heightOffset: number) {
    this.height = window.innerHeight - heightOffset - 40;
    this.subscription = resizeService.onResize$.subscribe(window => {
      ngZone.run(() => {
        this.height = window.innerHeight - heightOffset - 40;
      })
    })
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

}
